import { Wrapper } from '@klv/utils/wrapper';
import { Rive as RiveAtom } from '@klv/atoms/rive';

import * as styles from './styles/riveAnimation.module.scss';

import type { IRiveAnimation } from './types';

export const RiveAnimation = ({
  backgroundColor,
  className = '',
  contained = false,
  inset = false,
  padded = false,
  fadeIn = false,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  rive,
  ...props
}: IRiveAnimation) => {

  // Early return if no rive data
  if (!rive?.riveFile?.mediaItemUrl) {
    return null;
  }

  // Extract rive configuration from WordPress data
  const riveFile = { mediaItemUrl: rive.riveFile.mediaItemUrl };
  const layout = rive.riveData?.layout;
  const textRuns = rive.riveData?.textRuns || [];
  const ariaLabel = rive.riveData?.ariaLabel;

  return (
    <Wrapper
      className={className}
      fadeIn={fadeIn ? 0.25 : 0}
      grid={true}
      backgroundColor={backgroundColor}
      customPadding={customPadding}
      contained={contained}
      inlinePadding={padded}
      {...props}
    >
      <RiveAtom
        riveFile={riveFile}
        aspectRatio={layout?.aspectRatio}
        flexibleLayout={layout?.isFlexible}
        height={layout?.height}
        riveText={textRuns}
        ariaLabelText={ariaLabel}
        className={`${styles.rive} ${inset ? styles.inset : ''}`}
      />
    </Wrapper>
  );
};
